import React from 'react';
import classes from './reviews.module.css';
import Title from "../../containers/title/title";
import ReviewCard from './reviewCard/reviewCard';
import AverageReviewCard from './averageReviewCard/averageReviewCard';
import Trip from '../../../assets/images/trip.png';
import Facebook from '../../../assets/images/facebook-icon (1).png';
import Google from '../../../assets/images/google.png';
import Stars from '../../../assets/images/stars.png';

const Reviews = ({reviews}) => {
    const isEnglish = parseInt(localStorage.getItem('language')) === 1;
    
    const averageReviews = [
        {
            icon: Trip,
            webSite: isEnglish ? 'Trip Advisor' : 'تريب أدفايزر',
            rate: reviews?.platform_ratings?.trip_advisor?.rating,
            rateImg: Stars
        },
        {
            icon: Facebook,
            webSite: isEnglish ? 'Facebook' : 'فيسبوك',
            rate: reviews?.platform_ratings?.facebook?.rating,
            rateImg: Stars
        },
        {
            icon: Google,
            webSite: isEnglish ? 'Google' : 'جوجل',
            rate: reviews?.platform_ratings?.google_maps?.rating,
            rateImg: Stars
        }
    ]
    return (
        <div className={classes.Container}>
            <Title title={reviews?.title} />
            <div className={classes.Description}>
                <div className={classes.AverageReviews}>{averageReviews.map((averageReview,i) => <AverageReviewCard averageReview={averageReview} key={i} />)}</div>
                <div className={classes.PeopleReviews}>{reviews?.reviews?.map((review,i) => <ReviewCard review={review} key={i} />)}</div>
            </div>
        </div>
    )
}
export default Reviews;